"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7562],{

/***/ 55655:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "lR": function() { return /* binding */ isDepositRequired; },
/* harmony export */   "q7": function() { return /* binding */ completeDepositPayment; },
/* harmony export */   "x": function() { return /* binding */ getDepositStatus; }
/* harmony export */ });
/* unused harmony exports payDeposit, refundDeposit, refundDepositForClient, getRefundableDeposits */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(20414);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(53249);



/**
 * 디파짓 결제
 */ var payDeposit = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(data) {
        var response;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        ___WEBPACK_IMPORTED_MODULE_0__/* .apiServiceV2.post */ .sl.post("/match-deposit/pay", data)
                    ];
                case 1:
                    response = _state.sent();
                    return [
                        2,
                        response.data
                    ];
            }
        });
    });
    return function payDeposit(data) {
        return _ref.apply(this, arguments);
    };
}();
// 링크결제 토큰/완료 기록 API 제거
/**
 * 디파짓 상태 조회
 */ var getDepositStatus = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(matchUuid) {
        var response;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        ___WEBPACK_IMPORTED_MODULE_0__/* .apiServiceV2.get */ .sl.get("/match-deposit/status/".concat(matchUuid))
                    ];
                case 1:
                    response = _state.sent();
                    return [
                        2,
                        response.data
                    ];
            }
        });
    });
    return function getDepositStatus(matchUuid) {
        return _ref.apply(this, arguments);
    };
}();
/**
 * 디파짓 필요 여부 확인
 */ var isDepositRequired = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(matchUuid) {
        var ref, ref1, response, ref2, ref3, _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        ___WEBPACK_IMPORTED_MODULE_0__/* .apiServiceV2.get */ .sl.get("/match-deposit/required/".concat(matchUuid))
                    ];
                case 1:
                    response = _state.sent();
                    _tmp = {};
                    return [
                        2,
                        (_tmp.isRequired = (ref2 = (ref = response.data) === null || ref === void 0 ? void 0 : ref.isRequired) !== null && ref2 !== void 0 ? ref2 : false, _tmp.depositAmount = (ref3 = (ref1 = response.data) === null || ref1 === void 0 ? void 0 : ref1.depositAmount) !== null && ref3 !== void 0 ? ref3 : 100000, _tmp)
                    ];
            }
        });
    });
    return function isDepositRequired(matchUuid) {
        return _ref.apply(this, arguments);
    };
}();
/**
 * 디파짓 환불 (관리자용)
 */ var refundDeposit = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(data) {
        var response;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        ___WEBPACK_IMPORTED_MODULE_0__/* .apiServiceV2.post */ .sl.post("/match-deposit/refund", data)
                    ];
                case 1:
                    response = _state.sent();
                    return [
                        2,
                        response.data
                    ];
            }
        });
    });
    return function refundDeposit(data) {
        return _ref.apply(this, arguments);
    };
}();
/**
 * 클라이언트용 디파짓 환불 (전문가 수락 시 자동 환불)
 */ var refundDepositForClient = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(matchUuid) {
        var response, _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _tmp = {};
                    return [
                        4,
                        ___WEBPACK_IMPORTED_MODULE_0__/* .apiServiceV2.post */ .sl.post("/match-deposit/refund-for-client", (_tmp.matchUuid = matchUuid, _tmp))
                    ];
                case 1:
                    response = _state.sent();
                    return [
                        2,
                        response.data
                    ];
            }
        });
    });
    return function refundDepositForClient(matchUuid) {
        return _ref.apply(this, arguments);
    };
}();
/**
 * 환불 가능한 디파짓 목록 조회 (관리자용)
 */ var getRefundableDeposits = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function() {
        var response;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        ___WEBPACK_IMPORTED_MODULE_0__/* .apiServiceV2.get */ .sl.get("/match-deposit/refundable")
                    ];
                case 1:
                    response = _state.sent();
                    return [
                        2,
                        response.data
                    ];
            }
        });
    });
    return function getRefundableDeposits() {
        return _ref.apply(this, arguments);
    };
}();
var completeDepositPayment = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(data) {
        var response;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        ___WEBPACK_IMPORTED_MODULE_0__/* .apiServiceV2.post */ .sl.post("/match-deposit/complete", data)
                    ];
                case 1:
                    response = _state.sent();
                    return [
                        2,
                        response.data
                    ];
            }
        });
    });
    return function completeDepositPayment(data) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 71645:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "KS": function() { return /* binding */ SectionToggle; },
/* harmony export */   "ul": function() { return /* binding */ SummaryToggle; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_icons_material_AutoAwesome__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(43927);
/* harmony import */ var _mui_icons_material_ExpandLessRounded__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(23241);
/* harmony import */ var _mui_icons_material_ExpandMoreRounded__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(40876);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(29630);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61953);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(93481);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(19604);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(91655);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(54225);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);






var cleanText = function(value) {
    return String(value || "").replace(/\s+/g, " ").trim();
};
var splitByDelimiters = function(value) {
    var raw = String(value || "").replace(/\r/g, "\n").trim();
    if (!raw) return [];
    return raw.split(/\n|•/g).map(function(line) {
        return line.trim();
    }).filter(Boolean).map(function(line) {
        return line.replace(/^[-•·]\s*/, "").trim();
    });
};
var uniquePoints = function(items, max, maxLen) {
    var seen = new Set();
    var result = [];
    items.forEach(function(item) {
        var normalized = cleanText(item).replace(/^[-•]\s*/, "");
        if (!normalized) return;
        if (seen.has(normalized)) return;
        seen.add(normalized);
        result.push(normalized.slice(0, maxLen));
    });
    return result.slice(0, max);
};
var fromTextToPoints = function(value) {
    var max = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 3, maxLen = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 180;
    return uniquePoints(splitByDelimiters(value), max, maxLen);
};
var splitReasonLeadAndEffect = function(point) {
    var normalized = String(point || "").replace(/\r/g, "\n");
    var dashed = normalized.match(/^(.*?)\s+-\s+(.+)$/);
    if (dashed) {
        return {
            lead: cleanText(dashed[1]),
            tail: cleanText(dashed[2])
        };
    }
    var lines = normalized.split(/\n+/g).map(function(line) {
        return cleanText(line);
    }).filter(Boolean);
    if (lines.length >= 2) {
        return {
            lead: lines[0],
            tail: lines.slice(1).join(" ")
        };
    }
    return {
        lead: cleanText(normalized),
        tail: ""
    };
};
var SECTION_CONFIG = [
    {
        keys: [
            "suitabilityReason",
            "interviewInsights"
        ],
        label: "프로필 & 인터뷰 인사이트",
        color: "#3b82f6",
        bgColor: "#eff6ff",
        maxPerKey: [
            5,
            3
        ]
    },
    {
        keys: [
            "proposalHighlights"
        ],
        label: "제안서 핵심 포인트",
        color: "#8b5cf6",
        bgColor: "#f5f3ff",
        maxPerKey: [
            3
        ]
    }, 
];
var ensurePeriod = function(text) {
    var t = text.trim();
    if (!t) return t;
    return /[.!?。]$/.test(t) ? t : t + ".";
};
var ReasonBullet = function(param) {
    var point = param.point, id = param.id;
    var ref = splitReasonLeadAndEffect(point), lead = ref.lead, tail = ref.tail;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        sx: {
            fontSize: 14,
            color: "#374151",
            lineHeight: 1.65,
            mb: 0.35
        },
        children: [
            "•",
            " ",
            tail ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                component: "span",
                sx: {
                    fontWeight: 700,
                    color: "#1f2937",
                    fontSize: "inherit",
                    lineHeight: "inherit"
                },
                children: lead
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                component: "span",
                sx: {
                    fontSize: "inherit",
                    lineHeight: "inherit"
                },
                children: ensurePeriod(lead)
            }),
            tail ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                component: "span",
                sx: {
                    display: "block",
                    mt: 0.1,
                    pl: 1.5,
                    fontSize: "inherit",
                    lineHeight: "inherit"
                },
                children: ensurePeriod(tail)
            }) : null
        ]
    }, id);
};
var SectionToggle = function(param) {
    var label = param.label, color = param.color, bgColor = param.bgColor, points = param.points, expertId = param.expertId;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), open = ref[0], setOpen = ref[1];
    if (points.length === 0) return null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        sx: {
            border: "1.5px solid ".concat(bgColor),
            borderRadius: "10px",
            overflow: "hidden",
            backgroundColor: open ? "#fff" : bgColor,
            transition: "background-color 200ms"
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                onClick: function() {
                    return setOpen(function(prev) {
                        return !prev;
                    });
                },
                sx: {
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    px: 1.25,
                    py: 0.8,
                    cursor: "pointer",
                    userSelect: "none",
                    "&:hover": {
                        backgroundColor: "rgba(0,0,0,0.02)"
                    }
                },
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        sx: {
                            display: "flex",
                            alignItems: "center",
                            gap: 0.8
                        },
                        children: [
                            !open && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                sx: {
                                    fontSize: 10.5,
                                    color: color,
                                    backgroundColor: "rgba(255,255,255,0.7)",
                                    px: 0.7,
                                    py: 0.15,
                                    borderRadius: "3px",
                                    fontWeight: 600
                                },
                                children: "Click"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                sx: {
                                    fontSize: 13,
                                    fontWeight: 700,
                                    color: color
                                },
                                children: label
                            })
                        ]
                    }),
                    open ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_ExpandLessRounded__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                        sx: {
                            fontSize: 18,
                            color: color
                        }
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_ExpandMoreRounded__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                        sx: {
                            fontSize: 18,
                            color: color
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                in: open,
                timeout: 200,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                    sx: {
                        px: 1.25,
                        pb: 1.2,
                        pt: 0.3
                    },
                    children: points.map(function(point, i) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ReasonBullet, {
                            point: point,
                            id: "".concat(label, "-").concat(expertId, "-").concat(i)
                        }, "".concat(label, "-").concat(expertId, "-").concat(i));
                    })
                })
            })
        ]
    });
};
var SummaryToggle = function(param) {
    var headline = param.headline, decisionGuide = param.decisionGuide, expertId = param.expertId;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), open = ref[0], setOpen = ref[1];
    var color = "#059669";
    var bgColor = "#ecfdf5";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        sx: {
            border: "1.5px solid ".concat(bgColor),
            borderRadius: "10px",
            overflow: "hidden",
            backgroundColor: open ? "#fff" : bgColor,
            transition: "background-color 200ms"
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                onClick: function() {
                    return setOpen(function(prev) {
                        return !prev;
                    });
                },
                sx: {
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    px: 1.25,
                    py: 0.8,
                    cursor: "pointer",
                    userSelect: "none",
                    "&:hover": {
                        backgroundColor: "rgba(0,0,0,0.02)"
                    }
                },
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        sx: {
                            display: "flex",
                            alignItems: "center",
                            gap: 0.8
                        },
                        children: [
                            !open && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                sx: {
                                    fontSize: 10.5,
                                    color: color,
                                    backgroundColor: "rgba(255,255,255,0.7)",
                                    px: 0.7,
                                    py: 0.15,
                                    borderRadius: "3px",
                                    fontWeight: 600
                                },
                                children: "Click"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                sx: {
                                    fontSize: 13,
                                    fontWeight: 700,
                                    color: color
                                },
                                children: "Summary"
                            })
                        ]
                    }),
                    open ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_ExpandLessRounded__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                        sx: {
                            fontSize: 18,
                            color: color
                        }
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_ExpandMoreRounded__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                        sx: {
                            fontSize: 18,
                            color: color
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                in: open,
                timeout: 200,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                    sx: {
                        px: 1.25,
                        pb: 1.2,
                        pt: 0.3
                    },
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                            sx: {
                                fontSize: {
                                    xs: 13,
                                    md: 14
                                },
                                fontWeight: 700,
                                color: "#111827",
                                mb: 0.3
                            },
                            children: headline
                        }),
                        decisionGuide ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                            sx: {
                                fontSize: {
                                    xs: 12,
                                    md: 13
                                },
                                color: "#6b7280",
                                lineHeight: 1.7,
                                whiteSpace: "pre-line"
                            },
                            children: decisionGuide.replace(/([.!?]) /g, "$1\n")
                        }) : null
                    ]
                })
            })
        ]
    });
};
var ExpertSection = function(param) {
    var expert = param.expert, isLast = param.isLast, summary = param.summary;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        sx: {
            borderBottom: isLast ? "none" : "1px solid #e5e7eb",
            px: 1.5,
            pt: 0.5,
            pb: 1
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            sx: {
                display: "flex",
                flexDirection: "column",
                gap: 0.5
            },
            children: [
                (summary === null || summary === void 0 ? void 0 : summary.headline) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SummaryToggle, {
                    headline: summary.headline,
                    decisionGuide: summary.decisionGuide,
                    expertId: expert.matchedExpertDataUuid
                }) : null,
                SECTION_CONFIG.map(function(section) {
                    var allPoints = section.keys.flatMap(function(key, ki) {
                        return fromTextToPoints(expert[key], section.maxPerKey[ki], 260);
                    });
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SectionToggle, {
                        label: section.label,
                        color: section.color,
                        bgColor: section.bgColor,
                        points: allPoints,
                        expertId: expert.matchedExpertDataUuid
                    }, section.label);
                })
            ]
        })
    });
};
var ProposalAssistantReport = function(param) {
    var report = param.report, isLoading = param.isLoading, isGenerating = param.isGenerating, _isGeneratingOverall = param.isGeneratingOverall, isGeneratingOverall = _isGeneratingOverall === void 0 ? false : _isGeneratingOverall, generationError = param.generationError, onGenerate = param.onGenerate, onGenerateOverall = param.onGenerateOverall, _hasDeadlineSet = param.hasDeadlineSet, hasDeadlineSet = _hasDeadlineSet === void 0 ? false : _hasDeadlineSet, visibleExpertIds = param.visibleExpertIds, _showGenerateButton = param.showGenerateButton, showGenerateButton = _showGenerateButton === void 0 ? false : _showGenerateButton;
    var experts = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        var rows = (report === null || report === void 0 ? void 0 : report.experts) || [];
        if (!visibleExpertIds || visibleExpertIds.length === 0) return rows;
        var visibleSet = new Set(visibleExpertIds);
        return rows.filter(function(expert) {
            return visibleSet.has(expert.matchedExpertDataUuid);
        });
    }, [
        report === null || report === void 0 ? void 0 : report.experts,
        visibleExpertIds
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        sx: {
            width: "100%"
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                sx: {
                    display: "flex",
                    alignItems: "center",
                    gap: 0.75,
                    mb: 2
                },
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_AutoAwesome__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                        sx: {
                            color: "#7c3aed",
                            fontSize: {
                                xs: 20,
                                md: 22
                            }
                        }
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        sx: {
                            fontSize: {
                                xs: 18,
                                md: 22
                            },
                            fontWeight: 800,
                            color: "#111827",
                            lineHeight: 1.2,
                            flex: 1
                        },
                        children: "후보자 비교 분석 AI"
                    })
                ]
            }),
            generationError ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                severity: "warning",
                sx: {
                    mb: 2
                },
                children: generationError
            }) : null,
            isLoading && !report ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                sx: {
                    display: "flex",
                    flexDirection: "column",
                    gap: 1.5
                },
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                        variant: "rounded",
                        height: 64
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                        variant: "rounded",
                        height: 120
                    })
                ]
            }) : null,
            !isLoading && !report ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                sx: {
                    border: "1px dashed #d4bffc",
                    borderRadius: "12px",
                    background: "linear-gradient(145deg, rgba(250,247,255,0.96) 0%, rgba(255,255,255,0.98) 100%)",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    textAlign: "center",
                    py: 4,
                    px: 3
                },
                children: showGenerateButton ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                            sx: {
                                fontSize: {
                                    xs: 14,
                                    md: 16
                                },
                                color: "#374151",
                                mb: 1.2
                            },
                            children: "AI가 이 전문가의 제안서를 분석해 드립니다."
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                            variant: "contained",
                            onClick: function() {
                                return onGenerate(false);
                            },
                            disabled: isGenerating,
                            sx: {
                                borderRadius: "10px",
                                fontWeight: 700,
                                fontSize: {
                                    xs: 13,
                                    md: 15
                                },
                                backgroundColor: "#7c3aed",
                                "&:hover": {
                                    backgroundColor: "#6d28d9"
                                }
                            },
                            children: isGenerating ? "분석 중..." : "AI 분석 시작"
                        })
                    ]
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                            sx: {
                                fontSize: {
                                    xs: 15,
                                    md: 17
                                },
                                fontWeight: 700,
                                color: "#374151",
                                mb: 1.5
                            },
                            children: "아직 생성된 분석 리포트가 없습니다"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                            sx: {
                                fontSize: {
                                    xs: 13,
                                    md: 14
                                },
                                color: "#6b7280",
                                lineHeight: 1.7
                            },
                            children: [
                                "각 전문가의 ",
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("b", {
                                    children: "제안 검토"
                                }),
                                " 버튼을 눌러 업무 제안서를 확인하면,",
                                "\n",
                                "AI가 전문가를 종합적으로 분석합니다.",
                                "\n",
                                "분석이 완료되면 이곳에서 전문가별 비교 리포트를 확인할 수 있습니다."
                            ]
                        })
                    ]
                })
            }) : null,
            report ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    experts.length === 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        sx: {
                            p: 2
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                            severity: "info",
                            children: "비교 가능한 전문가 데이터가 없습니다."
                        })
                    }) : null,
                    experts.length > 0 && report.overallAssessment ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        sx: {
                            border: "1px solid #e5e7eb",
                            borderRadius: "12px",
                            backgroundColor: "#ffffff",
                            mb: 2.5,
                            overflow: "hidden"
                        },
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                sx: {
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                    px: 1.5,
                                    py: 0.8,
                                    backgroundColor: "#f8fafc",
                                    borderBottom: "1px solid #e5e7eb"
                                },
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                    sx: {
                                        fontSize: 14,
                                        fontWeight: 800,
                                        color: "#111827"
                                    },
                                    children: "AI 컨설턴트 총평"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                sx: {
                                    px: 2,
                                    py: 1.5
                                },
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                    sx: {
                                        fontSize: {
                                            xs: 13.5,
                                            md: 14.5
                                        },
                                        color: "#374151",
                                        lineHeight: 1.8,
                                        whiteSpace: "pre-line"
                                    },
                                    children: report.overallAssessment
                                })
                            })
                        ]
                    }) : null,
                    experts.length > 0 && !report.overallAssessment && hasDeadlineSet && onGenerateOverall ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        sx: {
                            display: "flex",
                            justifyContent: "center",
                            mb: 2.5
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                            variant: "outlined",
                            onClick: function() {
                                return onGenerateOverall();
                            },
                            disabled: isGeneratingOverall,
                            sx: {
                                borderRadius: "10px",
                                fontWeight: 700,
                                fontSize: {
                                    xs: 13,
                                    md: 14
                                },
                                borderColor: "#7c3aed",
                                color: "#7c3aed",
                                "&:hover": {
                                    borderColor: "#6d28d9",
                                    backgroundColor: "rgba(124,58,237,0.04)"
                                }
                            },
                            children: isGeneratingOverall ? "총평 생성 중..." : "AI 컨설턴트 총평 생성하기"
                        })
                    }) : null,
                    experts.length > 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        sx: {
                            overflowX: "auto",
                            border: "1px solid #e5e7eb",
                            borderRadius: "12px",
                            backgroundColor: "#ffffff",
                            mb: 2.5
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            sx: {
                                minWidth: 680
                            },
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                    sx: {
                                        display: "grid",
                                        gridTemplateColumns: "160px minmax(400px, 1fr)",
                                        borderBottom: "1px solid #e5e7eb",
                                        backgroundColor: "#f8fafc",
                                        alignItems: "center"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                            sx: {
                                                p: 1.4,
                                                fontSize: 14,
                                                fontWeight: 800,
                                                color: "#111827",
                                                textAlign: "center"
                                            },
                                            children: "전문가"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                            sx: {
                                                p: 1.4,
                                                fontSize: 14,
                                                fontWeight: 800,
                                                color: "#111827",
                                                borderLeft: "1px solid #e5e7eb",
                                                textAlign: "center"
                                            },
                                            children: "AI 컨설턴트 코멘트"
                                        })
                                    ]
                                }),
                                experts.map(function(expert, index) {
                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                        sx: {
                                            display: "grid",
                                            gridTemplateColumns: "160px minmax(400px, 1fr)",
                                            borderBottom: index === experts.length - 1 ? "none" : "1px solid #e5e7eb",
                                            alignItems: "stretch"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                                sx: {
                                                    p: 1.4,
                                                    display: "flex",
                                                    flexDirection: "column",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    textAlign: "center"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                                        sx: {
                                                            fontSize: 16,
                                                            fontWeight: 800,
                                                            color: "#111827",
                                                            lineHeight: 1.3
                                                        },
                                                        children: expert.expertName
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                                        sx: {
                                                            mt: 0.3,
                                                            fontSize: 13,
                                                            color: "#6b7280"
                                                        },
                                                        children: expert.expertJob || "직무 정보 없음"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                                sx: {
                                                    p: 1.4,
                                                    borderLeft: "1px solid #e5e7eb",
                                                    display: "flex",
                                                    alignItems: "center"
                                                },
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                                    sx: {
                                                        fontSize: {
                                                            xs: 13.5,
                                                            md: 14.5
                                                        },
                                                        color: "#374151",
                                                        lineHeight: 1.7
                                                    },
                                                    children: expert.consultantComment || ""
                                                })
                                            })
                                        ]
                                    }, "table-".concat(expert.matchedExpertDataUuid));
                                })
                            ]
                        })
                    }) : null,
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        sx: {
                            border: "1px solid #e5e7eb",
                            borderRadius: "12px",
                            backgroundColor: "#ffffff",
                            overflow: "hidden"
                        },
                        children: experts.map(function(expert, index) {
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                sx: {
                                    borderBottom: index === experts.length - 1 ? "none" : "1px solid #e5e7eb"
                                },
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                        sx: {
                                            display: "flex",
                                            alignItems: "center",
                                            gap: 1,
                                            px: 1.5,
                                            py: 0.7,
                                            backgroundColor: "#f1f5f9",
                                            borderBottom: "1px solid #e2e8f0",
                                            borderTopLeftRadius: index === 0 ? "12px" : 0,
                                            borderTopRightRadius: index === 0 ? "12px" : 0
                                        },
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                            sx: {
                                                fontSize: {
                                                    xs: 14,
                                                    md: 15
                                                },
                                                fontWeight: 700,
                                                color: "#374151"
                                            },
                                            children: expert.expertName
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ExpertSection, {
                                        expert: expert,
                                        isLast: true,
                                        summary: expert.expertHeadline ? {
                                            headline: expert.expertHeadline,
                                            decisionGuide: expert.expertDecisionGuide
                                        } : undefined
                                    })
                                ]
                            }, expert.matchedExpertDataUuid);
                        })
                    })
                ]
            }) : null
        ]
    });
};
/* harmony default export */ __webpack_exports__["ZP"] = (ProposalAssistantReport);


/***/ }),

/***/ 27562:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "op": function() { return /* binding */ CustomButton; }
/* harmony export */ });
/* unused harmony exports ProposalAcceptDialog, NegotiationButton */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_40__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(29815);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(20414);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(61953);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(54225);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(29630);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(93481);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(19604);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_36__ = __webpack_require__(77745);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_37__ = __webpack_require__(95398);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_42__ = __webpack_require__(32631);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_43__ = __webpack_require__(23978);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_44__ = __webpack_require__(76779);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_45__ = __webpack_require__(55343);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_46__ = __webpack_require__(31944);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_47__ = __webpack_require__(22841);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_48__ = __webpack_require__(8519);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_50__ = __webpack_require__(29620);
/* harmony import */ var _mui_icons_material_AutoAwesomeRounded__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(80097);
/* harmony import */ var _mui_icons_material_ExpandLessRounded__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(23241);
/* harmony import */ var _mui_icons_material_ExpandMoreRounded__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(40876);
/* harmony import */ var _src_component_SignComponent__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34489);
/* harmony import */ var _src_hook_useGlobalDialog__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(62766);
/* harmony import */ var _src_hook_useLoader__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26076);
/* harmony import */ var _src_hook_useUser__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(92859);
/* harmony import */ var _src_state__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(51413);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var react_hook_form__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(87536);
/* harmony import */ var recoil__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(4480);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(77366);
/* harmony import */ var _src_api_match__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(91088);
/* harmony import */ var _mui_material_Rating__WEBPACK_IMPORTED_MODULE_51__ = __webpack_require__(89057);
/* harmony import */ var _src_api_match_deposit__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(55655);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(30381);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var moment_locale_ko__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(33730);
/* harmony import */ var moment_locale_ko__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(moment_locale_ko__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(67294);
/* harmony import */ var react_query__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(88767);
/* harmony import */ var _base_BasicFormWrapper__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(66660);
/* harmony import */ var _mui_lab__WEBPACK_IMPORTED_MODULE_49__ = __webpack_require__(52029);
/* harmony import */ var _mui_x_date_pickers__WEBPACK_IMPORTED_MODULE_38__ = __webpack_require__(50720);
/* harmony import */ var _mui_x_date_pickers__WEBPACK_IMPORTED_MODULE_41__ = __webpack_require__(150);
/* harmony import */ var _mui_x_date_pickers_AdapterMoment__WEBPACK_IMPORTED_MODULE_39__ = __webpack_require__(42298);
/* harmony import */ var _src_utils_CalculationUtils__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(81812);
/* harmony import */ var linkify_react__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(4913);
/* harmony import */ var _base_OnePointDialog__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(3465);
/* harmony import */ var _src_hook_useProposalAssistant__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(81762);
/* harmony import */ var _ProposalAssistantReport__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(71645);







function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	display: flex;\n	flex-direction: row;\n	align-content: flex-end;\n	gap: 8px;\n	align-items: center;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	display: flex;\n	flex-direction: column;\n	gap: 8px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	.MuiPaper-root {\n		border-radius: 18px;\n	}\n	.MuiDialogTitle-root {\n		background-color: var(--primary);\n		color: white;\n\n		.title-box {\n			display: flex;\n			flex-direction: row;\n			justify-content: space-between;\n			align-items: center;\n\n			.title {\n				font-size: 30px;\n				font-style: normal;\n				font-weight: 700;\n			}\n\n			.icon {\n				width: 60px;\n				height: 60px;\n\n				.logo {\n					width: 100%;\n				}\n			}\n		}\n	}\n\n	.button-group {\n		display: flex;\n		flex-direction: row;\n		gap: 10px;\n		flex-wrap: wrap;\n	}\n\n	.description {\n		font-size: 20px;\n		font-weight: bold;\n		margin-top: 30px;\n\n		.blue {\n			color: var(--primary);\n		}\n	}\n\n	.description-mini {\n		font-size: 16px;\n	}\n\n	@media screen and (max-width: 600px) {\n		.description-mini {\n			display: none;\n		}\n	}\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	font-size: 20px;\n	font-style: normal;\n	font-weight: bold;\n	line-height: normal;\n	color: rgb(8, 126, 255);\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	height: 48px;\n	background-color: var(--primary);\n	border: none;\n	font-size: 24px;\n	font-weight: bold;\n	border-radius: 16px;\n	color: white;\n	transition: all 0.2s ease;\n\n	&:hover {\n		color: white !important;\n		filter: brightness(0.9);\n	}\n\n	@media screen and (max-width: 768px) {\n		font-size: 16px;\n		padding: 3px 8px;\n	}\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	min-height: 52px;\n	font-size: 15px;\n	font-weight: 600;\n	border-radius: 12px;\n	border: 1.5px solid #d1d5db;\n	color: #4b5563;\n	background-color: #ffffff;\n	transition: all 0.2s ease;\n\n	&:hover {\n		color: #374151 !important;\n		background-color: #f3f4f6 !important;\n		border-color: #9ca3af !important;\n	}\n\n	@media screen and (max-width: 768px) {\n		font-size: 14px;\n	}\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}






























var rejectReason = [
    "역량이나 전문성에 확신이 없어요",
    "적극성이나 의지가 부족해보여요",
    "저희 회사와는 컬쳐핏이 맞지 않아요",
    "업무 방식과 시간대 등 조건이 맞지 않아요",
    "최종 제안 금액이 높아 부담돼요",
    "전문가는 만족스럽지만 내부 사정이 변경되었어요",
    "기타", 
];
var splitReasonLeadAndEffect = function(point) {
    var normalized = String(point || "").replace(/\r/g, "\n");
    var dashed = normalized.match(/^(.*?)\s+-\s+(.+)$/);
    if (dashed) return {
        lead: dashed[1].trim(),
        tail: dashed[2].trim()
    };
    var lines = normalized.split(/\n+/g).map(function(l) {
        return l.trim();
    }).filter(Boolean);
    if (lines.length >= 2) return {
        lead: lines[0],
        tail: lines.slice(1).join(" ")
    };
    return {
        lead: normalized.trim(),
        tail: ""
    };
};
var fromTextToLines = function(value) {
    var max = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 5;
    var raw = String(value || "").replace(/\r/g, "\n").trim();
    if (!raw) return [];
    return raw.split(/\n|•/g).map(function(l) {
        return l.replace(/^[-•·]\s*/, "").trim();
    }).filter(Boolean).slice(0, max);
};
var ProposalView = function(props) {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_7__.useRouter)();
    var uuid = props.uuid, isExpert = props.isExpert, darkTheme = props.darkTheme, matchedExpertDataUuid = props.matchedExpertDataUuid, exportUuid = props.exportUuid, isLastOne = props.isLastOne;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_14__.useState)(false), open = ref[0], setOpen = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_14__.useState)(false), openDepositRefundModal = ref1[0], setOpenDepositRefundModal = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_14__.useState)(false), isAiOpen = ref2[0], setIsAiOpen = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_14__.useState)(false), openAiFeedbackModal = ref3[0], setOpenAiFeedbackModal = ref3[1];
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_14__.useState)(null), aiFeedbackRating = ref4[0], setAiFeedbackRating = ref4[1];
    var ref5 = (0,react__WEBPACK_IMPORTED_MODULE_14__.useState)(""), aiFeedbackComment = ref5[0], setAiFeedbackComment = ref5[1];
    var ref6 = (0,react__WEBPACK_IMPORTED_MODULE_14__.useState)(false), aiFeedbackSubmitted = ref6[0], setAiFeedbackSubmitted = ref6[1];
    var queryClient = (0,react_query__WEBPACK_IMPORTED_MODULE_15__.useQueryClient)();
    var ref7 = (0,react__WEBPACK_IMPORTED_MODULE_14__.useState)(0), floatingButtonWidth = ref7[0], setFloatingButtonWidth = ref7[1];
    var user = (0,_src_hook_useUser__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)().user;
    var ref8 = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_21__/* .useForm */ .cI)({
        defaultValues: {
            desiredStartDate: new Date(),
            useSupportFund: null,
            supportInfo: null,
            understandSupportFund: false
        },
        mode: "onBlur"
    }), handleSubmit = ref8.handleSubmit, control = ref8.control, setValue = ref8.setValue, setError = ref8.setError, clearErrors = ref8.clearErrors, formState = ref8.formState, getFieldState = ref8.getFieldState, reset = ref8.reset, getValues = ref8.getValues, watch = ref8.watch;
    var ref9 = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_21__/* .useForm */ .cI)({
        reValidateMode: "onChange",
        defaultValues: {
            formResponse: "",
            etc: ""
        }
    }), rejectHandleOnSubmit = ref9.handleSubmit, errors = ref9.formState.errors, controlReject = ref9.control, resetReject = ref9.reset, watchReject = ref9.watch;
    var useSupportFund = watch("useSupportFund");
    (0,react__WEBPACK_IMPORTED_MODULE_14__.useEffect)(function() {
        if (useSupportFund === false) {
            setValue("supportInfo", null);
        }
    }, [
        useSupportFund
    ]);
    var withLoader = (0,_src_hook_useLoader__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)();
    var openDialog = (0,_src_hook_useGlobalDialog__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)().openDialog;
    var setSnackbareState = (0,recoil__WEBPACK_IMPORTED_MODULE_8__/* .useSetRecoilState */ .Zl)(_src_state__WEBPACK_IMPORTED_MODULE_6__/* .globalSnackbarState */ .j8);
    var ref10 = (0,react__WEBPACK_IMPORTED_MODULE_14__.useState)(false), openRejectModal = ref10[0], setOpenRejectModal = ref10[1];
    var ref11 = (0,react_query__WEBPACK_IMPORTED_MODULE_15__.useMutation)(_src_api_match__WEBPACK_IMPORTED_MODULE_10__.rejectProposalByClient, {
        onSuccess: function(data) {
            if (data.isSuccess) {
                // 마지막 거절일 때 디파짓 환불 완료 모달 표시
                if (isLastOne) {
                    setOpenRejectModal(false);
                    setOpenDepositRefundModal(true);
                    setSnackbareState("제안서가 거절되었습니다.");
                    setTimeout(function() {
                        setSnackbareState("");
                    }, 3000);
                } else {
                    // 일반 거절인 경우 모달 닫고 페이지 이동
                    setOpenRejectModal(false);
                    setSnackbareState("제안서가 거절되었습니다. 3초 후 메인 페이지로 이동합니다.");
                    setTimeout(function() {
                        router.replace("/match/my");
                    }, 3000);
                }
            } else {
                setSnackbareState("죄송합니다. 채널톡으로 문의 부탁드립니다.");
            }
        },
        onError: function() {
            setSnackbareState("죄송합니다. 채널톡으로 문의 부탁드립니다.");
        }
    }), mutateHandleOnClickRejectByClient = ref11.mutate, isLoadingHandleOnClickRejectByClient = ref11.isLoading;
    var ref12 = (0,react_query__WEBPACK_IMPORTED_MODULE_15__.useMutation)(_src_api_match__WEBPACK_IMPORTED_MODULE_10__.cancelProposalAccept, {
        onSuccess: function(data) {
            if (data.isSuccess) {
                setSnackbareState("제안서 수락이 취소되었습니다. 원래 상태로 복구되었습니다.");
                setProposal((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z)({}, proposal), {
                    isAccepted: ""
                }));
                // 페이지 새로고침하여 최신 상태 반영
                setTimeout(function() {
                    window.location.reload();
                }, 2000);
            } else {
                setSnackbareState("죄송합니다. 채널톡으로 문의 부탁드립니다.");
            }
        },
        onError: function() {
            setSnackbareState("죄송합니다. 채널톡으로 문의 부탁드립니다.");
        }
    }), mutateCancelProposalAccept = ref12.mutate, isLoadingCancelProposalAccept = ref12.isLoading;
    var ref13 = (0,react__WEBPACK_IMPORTED_MODULE_14__.useState)({
        matchUuid: "",
        proposalUuid: "",
        fileUrl: "",
        client: "",
        expert: "",
        purpose: "",
        plan: "",
        timeopt: "",
        cost: "",
        expertCost: "",
        comment: "",
        isAccepted: "",
        desiredStartDate: "",
        serviceType: "",
        dateRequestConfirmProposal: null,
        dateAcceptDeadline: null,
        costTen: 0,
        costFifteen: 0,
        costTwenty: 0,
        workType: "",
        workTypeComment: ""
    }), proposal = ref13[0], setProposal = ref13[1];
    (0,react__WEBPACK_IMPORTED_MODULE_14__.useEffect)(function() {
        if (proposal.desiredStartDate) {
            setValue("desiredStartDate", new Date(proposal.desiredStartDate));
        }
    }, [
        proposal.desiredStartDate
    ]);
    var data = (0,react_query__WEBPACK_IMPORTED_MODULE_15__.useQuery)([
        "getProposalData",
        uuid
    ], /*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_24__/* ["default"] */ .Z)(function() {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_25__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        withLoader((0,_src_api_match__WEBPACK_IMPORTED_MODULE_10__.getProposalDetail)(uuid, matchedExpertDataUuid || ""), "로딩 중입니다\n1~3초 정도 소요됩니다")
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    }), {
        refetchOnWindowFocus: false,
        refetchOnMount: false,
        retryOnMount: false,
        staleTime: Infinity,
        cacheTime: Infinity,
        onError: function(error) {
            setSnackbareState(error.errorMessage || error.message);
            router.replace("/");
        }
    }).data;
    var ref14 = (0,react_query__WEBPACK_IMPORTED_MODULE_15__.useQuery)([
        "depositStatus",
        proposal.matchUuid
    ], function() {
        return (0,_src_api_match_deposit__WEBPACK_IMPORTED_MODULE_11__/* .getDepositStatus */ .x)(proposal.matchUuid);
    }, {
        enabled: !!proposal.matchUuid,
        refetchOnWindowFocus: false,
        retry: false,
        staleTime: 50000,
        cacheTime: 50000
    }), depositStatus = ref14.data;
    var proposalAssistant = (0,_src_hook_useProposalAssistant__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)(!isExpert && proposal.matchUuid ? proposal.matchUuid : undefined);
    (0,react__WEBPACK_IMPORTED_MODULE_14__.useEffect)(function() {
        if (data) {
            setProposal(data);
        }
    }, [
        data
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_14__.useEffect)(function() {
        setTimeout(function() {
            return handleWidth();
        }, 200);
        window.addEventListener("resize", handleWidth);
        return function() {
            window.removeEventListener("resize", handleWidth);
        };
    }, []);
    var handleWidth = function() {
        var ref;
        setFloatingButtonWidth(((ref = document.getElementById("proposal-wrapper")) === null || ref === void 0 ? void 0 : ref.offsetWidth) || window.innerWidth);
    };
    var handleOnClickAccept = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_24__/* ["default"] */ .Z)(function(data) {
            var result, _tmp, _tmp1, _tmp2, _tmp3, error;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_25__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        setOpen(false);
                        _tmp = {};
                        _tmp1 = {};
                        return [
                            4,
                            withLoader((0,_src_api_match__WEBPACK_IMPORTED_MODULE_10__.acceptProposal)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z)(_tmp, data), (_tmp1.matchUuid = proposal.matchUuid, _tmp1.proposalUuid = proposal.proposalUuid, _tmp1.matchedExpertDataUuid = matchedExpertDataUuid, _tmp1))), "전송 중")
                        ];
                    case 1:
                        result = _state.sent();
                        _tmp2 = {};
                        _tmp3 = {};
                        if (result.isSuccess) {
                            // depositUuid가 존재하는 경우만 환불 모달 표시
                            if (depositStatus === null || depositStatus === void 0 ? void 0 : depositStatus.depositUuid) {
                                setOpenDepositRefundModal(true);
                            }
                            setSnackbareState("제안 수락이 완료되었습니다!\n이메일과 알림톡으로 이후 프로세스를 안내드리겠습니다");
                            setProposal((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z)(_tmp2, proposal), (_tmp3.isAccepted = "TRUE", _tmp3)));
                            // AI 후보자 분석 리포트가 있으면 피드백 모달 표시
                            if (proposalAssistant.report) {
                                setOpenAiFeedbackModal(true);
                            }
                            setTimeout(function() {
                                queryClient.refetchQueries([
                                    "getMatchs"
                                ]);
                                window.open("https://notion.1point.kr/referral");
                            }, 2000);
                        }
                        return [
                            3,
                            3
                        ];
                    case 2:
                        error = _state.sent();
                        setSnackbareState(error.errorMessage || error.message);
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleOnClickAccept(data) {
            return _ref.apply(this, arguments);
        };
    }();
    var isValidDate = moment__WEBPACK_IMPORTED_MODULE_12___default()(proposal.desiredStartDate).isValid();
    if (!proposal.proposalUuid) {
        return null;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_base_BasicFormWrapper__WEBPACK_IMPORTED_MODULE_16__/* .Wrapper */ .im, {
                    style: {
                        gap: 20,
                        padding: "20px"
                    },
                    id: "proposal-wrapper",
                    children: [
                        (depositStatus === null || depositStatus === void 0 ? void 0 : depositStatus.depositUuid) && user.isLogin && user.userType === 1 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                            style: {
                                backgroundColor: "#fff3cd",
                                border: "1px solid #ffeaa7",
                                borderRadius: "12px",
                                padding: "20px",
                                marginBottom: "24px",
                                boxShadow: "0 2px 8px rgba(255, 193, 7, 0.15)"
                            },
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                    style: {
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "12px",
                                        marginBottom: "8px"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                            style: {
                                                width: "24px",
                                                height: "24px",
                                                backgroundColor: "#ffc107",
                                                borderRadius: "50%",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                fontSize: "14px",
                                                color: "#fff",
                                                fontWeight: "bold"
                                            },
                                            children: "\uD83D\uDCA1"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                            style: {
                                                fontSize: "16px",
                                                fontWeight: "700",
                                                color: "#856404"
                                            },
                                            children: "서비스 보증금 환불 안내"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                    style: {
                                        fontSize: "14px",
                                        lineHeight: "1.6",
                                        color: "#856404",
                                        paddingLeft: "36px"
                                    },
                                    children: [
                                        "전문가 고용 또는 모든 후보 거절 시 3일 이내에 환불이 완료됩니다.",
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("br", {}),
                                        "서비스 진행을 하지 않으시더라도 모든 후보를 거절하셔야 환불이 진행됩니다."
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_base_BasicFormWrapper__WEBPACK_IMPORTED_MODULE_16__/* .WrapperContainer */ .t4, {
                            style: {
                                marginBottom: "24px"
                            },
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_base_BasicFormWrapper__WEBPACK_IMPORTED_MODULE_16__/* .TitleWrapper */ .$t, {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                        className: "top",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                id: "top-title",
                                                style: {
                                                    fontSize: "24px",
                                                    fontWeight: "700"
                                                },
                                                children: "전문가 ".concat(proposal.expert)
                                            })
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_src_component_SignComponent__WEBPACK_IMPORTED_MODULE_2__/* .EmptySpace */ .zV, {
                                    space: 24
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                    style: {
                                        display: "flex",
                                        gap: "12px",
                                        flexWrap: "wrap",
                                        marginBottom: "20px"
                                    },
                                    children: [
                                        (proposal === null || proposal === void 0 ? void 0 : proposal.desiredStartDate) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                            style: {
                                                flex: 1,
                                                minWidth: "200px",
                                                backgroundColor: "#f8f9fa",
                                                padding: "14px 18px",
                                                borderRadius: "8px",
                                                border: "1px solid #e9ecef"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                    style: {
                                                        fontSize: "12px",
                                                        color: "#6c757d",
                                                        marginBottom: "4px",
                                                        fontWeight: 500
                                                    },
                                                    children: "업무 시작 가능일"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                                    style: {
                                                        fontSize: "15px",
                                                        fontWeight: 700,
                                                        color: "#212529"
                                                    },
                                                    children: [
                                                        moment__WEBPACK_IMPORTED_MODULE_12___default()(proposal.desiredStartDate).format("YYYY.MM.DD"),
                                                        " (",
                                                        moment__WEBPACK_IMPORTED_MODULE_12___default()(proposal.desiredStartDate).format("ddd"),
                                                        ")"
                                                    ]
                                                })
                                            ]
                                        }),
                                        (proposal === null || proposal === void 0 ? void 0 : proposal.dateAcceptDeadline) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                            style: {
                                                flex: 1,
                                                minWidth: "200px",
                                                backgroundColor: "#fef3c7",
                                                padding: "14px 18px",
                                                borderRadius: "8px",
                                                borderLeft: "4px solid #f59e0b"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                    style: {
                                                        fontSize: "12px",
                                                        color: "#92400e",
                                                        marginBottom: "4px",
                                                        fontWeight: 500
                                                    },
                                                    children: "제안서 검토 기한"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                                    style: {
                                                        fontSize: "15px",
                                                        fontWeight: 700,
                                                        color: "#b45309"
                                                    },
                                                    children: [
                                                        moment__WEBPACK_IMPORTED_MODULE_12___default()(proposal.dateAcceptDeadline).format("YYYY.MM.DD"),
                                                        " (",
                                                        moment__WEBPACK_IMPORTED_MODULE_12___default()(proposal.dateAcceptDeadline).format("ddd"),
                                                        ")"
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                !isExpert && function() {
                                    var expertReport = proposalAssistant.expertReportMap.get(matchedExpertDataUuid);
                                    var suitLines = fromTextToLines(expertReport === null || expertReport === void 0 ? void 0 : expertReport.suitabilityReason, 5);
                                    var proposalLines = fromTextToLines(expertReport === null || expertReport === void 0 ? void 0 : expertReport.proposalHighlights, 3);
                                    var interviewLines = fromTextToLines(expertReport === null || expertReport === void 0 ? void 0 : expertReport.interviewInsights, 3);
                                    var hasContent = suitLines.length > 0 || proposalLines.length > 0 || interviewLines.length > 0;
                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z, {
                                        sx: {
                                            mb: 2.5,
                                            border: "1.5px solid #d4bffc",
                                            borderRadius: "12px",
                                            background: "linear-gradient(180deg, rgba(243,236,255,0.95) 0%, rgba(250,247,255,0.95) 100%)",
                                            boxShadow: "0 2px 8px rgba(124, 58, 237, 0.08)",
                                            overflow: "hidden"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_27__/* ["default"] */ .Z, {
                                                fullWidth: true,
                                                variant: "text",
                                                onClick: function() {
                                                    return setIsAiOpen(function(prev) {
                                                        return !prev;
                                                    });
                                                },
                                                startIcon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_icons_material_AutoAwesomeRounded__WEBPACK_IMPORTED_MODULE_28__/* ["default"] */ .Z, {
                                                    sx: {
                                                        fontSize: 16,
                                                        color: "#7c3aed"
                                                    }
                                                }),
                                                endIcon: isAiOpen ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_icons_material_ExpandLessRounded__WEBPACK_IMPORTED_MODULE_29__/* ["default"] */ .Z, {
                                                    sx: {
                                                        fontSize: 18
                                                    }
                                                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_icons_material_ExpandMoreRounded__WEBPACK_IMPORTED_MODULE_30__/* ["default"] */ .Z, {
                                                    sx: {
                                                        fontSize: 18
                                                    }
                                                }),
                                                sx: {
                                                    width: "100%",
                                                    border: "none",
                                                    borderRadius: isAiOpen ? "12px 12px 0 0" : "12px",
                                                    background: "transparent",
                                                    justifyContent: "space-between",
                                                    textTransform: "none",
                                                    px: 1.25,
                                                    py: 0.9,
                                                    minHeight: 44,
                                                    "& .MuiButton-startIcon": {
                                                        marginRight: "6px"
                                                    },
                                                    "& .MuiButton-endIcon": {
                                                        marginLeft: "6px",
                                                        color: "#7c3aed"
                                                    },
                                                    "&:hover": {
                                                        background: "rgba(243,236,255,0.45)"
                                                    }
                                                },
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z, {
                                                    sx: {
                                                        display: "flex",
                                                        alignItems: "center",
                                                        gap: 1
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_31__/* ["default"] */ .Z, {
                                                            sx: {
                                                                fontSize: "13.5px",
                                                                fontWeight: 700,
                                                                color: "#5b21b6",
                                                                lineHeight: 1.35
                                                            },
                                                            children: "AI 후보자 분석"
                                                        }),
                                                        !isAiOpen && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_31__/* ["default"] */ .Z, {
                                                            sx: {
                                                                fontSize: "11px",
                                                                color: "#7c3aed",
                                                                backgroundColor: "rgba(124, 58, 237, 0.08)",
                                                                px: 0.8,
                                                                py: 0.2,
                                                                borderRadius: "4px",
                                                                fontWeight: 600
                                                            },
                                                            children: "Click"
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_32__/* ["default"] */ .Z, {
                                                in: isAiOpen,
                                                timeout: 220,
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z, {
                                                    sx: {
                                                        width: "100%",
                                                        borderTop: "1px solid #e9d5ff",
                                                        backgroundColor: "#faf8ff",
                                                        p: 1.35
                                                    },
                                                    children: [
                                                        proposalAssistant.generationError ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_33__/* ["default"] */ .Z, {
                                                            severity: "warning",
                                                            sx: {
                                                                width: "100%",
                                                                mb: 1.25
                                                            },
                                                            children: proposalAssistant.generationError
                                                        }) : null,
                                                        (proposalAssistant.isLoading || proposalAssistant.isGenerating) && !expertReport ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z, {
                                                            sx: {
                                                                textAlign: "center",
                                                                py: 2
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z, {
                                                                    sx: {
                                                                        display: "inline-block",
                                                                        width: 28,
                                                                        height: 28,
                                                                        border: "3px solid #e9d5ff",
                                                                        borderTop: "3px solid #7c3aed",
                                                                        borderRadius: "50%",
                                                                        animation: "spin 0.8s linear infinite",
                                                                        "@keyframes spin": {
                                                                            "0%": {
                                                                                transform: "rotate(0deg)"
                                                                            },
                                                                            "100%": {
                                                                                transform: "rotate(360deg)"
                                                                            }
                                                                        },
                                                                        mb: 1.2
                                                                    }
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_31__/* ["default"] */ .Z, {
                                                                    sx: {
                                                                        fontSize: "13.5px",
                                                                        color: "#5b21b6",
                                                                        fontWeight: 600
                                                                    },
                                                                    children: "AI가 제안서를 분석하고 있습니다..."
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_31__/* ["default"] */ .Z, {
                                                                    sx: {
                                                                        fontSize: "12px",
                                                                        color: "#9ca3af",
                                                                        mt: 0.5
                                                                    },
                                                                    children: "약 30초~1분 정도 소요됩니다"
                                                                })
                                                            ]
                                                        }) : null,
                                                        !proposalAssistant.isLoading && !proposalAssistant.isGenerating && !expertReport ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z, {
                                                            sx: {
                                                                textAlign: "center",
                                                                py: 1.5
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_31__/* ["default"] */ .Z, {
                                                                    sx: {
                                                                        fontSize: "13.5px",
                                                                        color: "#4b5563",
                                                                        lineHeight: 1.6,
                                                                        mb: 1.2
                                                                    },
                                                                    children: "AI가 이 전문가의 제안서를 분석해 드립니다."
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_27__/* ["default"] */ .Z, {
                                                                    variant: "contained",
                                                                    size: "small",
                                                                    onClick: function() {
                                                                        return proposalAssistant.generateReport(false, matchedExpertDataUuid);
                                                                    },
                                                                    disabled: proposalAssistant.isGenerating,
                                                                    sx: {
                                                                        borderRadius: "8px",
                                                                        fontWeight: 700,
                                                                        fontSize: 13,
                                                                        backgroundColor: "#7c3aed",
                                                                        "&:hover": {
                                                                            backgroundColor: "#6d28d9"
                                                                        }
                                                                    },
                                                                    children: proposalAssistant.isGenerating ? "분석 중..." : "AI 분석 시작"
                                                                })
                                                            ]
                                                        }) : null,
                                                        hasContent ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z, {
                                                                sx: {
                                                                    display: "flex",
                                                                    flexDirection: "column",
                                                                    gap: 1
                                                                },
                                                                children: [
                                                                    (expertReport === null || expertReport === void 0 ? void 0 : expertReport.consultantComment) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z, {
                                                                        sx: {
                                                                            px: 1.25,
                                                                            py: 1,
                                                                            borderRadius: "10px",
                                                                            backgroundColor: "#f8fafc",
                                                                            border: "1px solid #e5e7eb"
                                                                        },
                                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_31__/* ["default"] */ .Z, {
                                                                            sx: {
                                                                                fontSize: 13.5,
                                                                                color: "#374151",
                                                                                lineHeight: 1.7
                                                                            },
                                                                            children: expertReport.consultantComment
                                                                        })
                                                                    }) : null,
                                                                    (expertReport === null || expertReport === void 0 ? void 0 : expertReport.expertHeadline) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_ProposalAssistantReport__WEBPACK_IMPORTED_MODULE_20__/* .SummaryToggle */ .ul, {
                                                                        headline: expertReport.expertHeadline,
                                                                        decisionGuide: expertReport.expertDecisionGuide,
                                                                        expertId: matchedExpertDataUuid
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_ProposalAssistantReport__WEBPACK_IMPORTED_MODULE_20__/* .SectionToggle */ .KS, {
                                                                        label: "프로필 \xb7 인터뷰 인사이트",
                                                                        color: "#3b82f6",
                                                                        bgColor: "#eff6ff",
                                                                        points: (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_34__/* ["default"] */ .Z)(suitLines).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_34__/* ["default"] */ .Z)(interviewLines)),
                                                                        expertId: matchedExpertDataUuid
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_ProposalAssistantReport__WEBPACK_IMPORTED_MODULE_20__/* .SectionToggle */ .KS, {
                                                                        label: "제안서 핵심 포인트",
                                                                        color: "#8b5cf6",
                                                                        bgColor: "#f5f3ff",
                                                                        points: proposalLines,
                                                                        expertId: matchedExpertDataUuid
                                                                    })
                                                                ]
                                                            })
                                                        }) : null
                                                    ]
                                                })
                                            })
                                        ]
                                    });
                                }(),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Row, {
                                    style: {
                                        gap: 16,
                                        flexDirection: "column",
                                        justifyContent: "flex-start",
                                        alignItems: "flex-start",
                                        marginBottom: "20px"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                            className: "detail-title",
                                            style: {
                                                fontSize: "20px",
                                                fontWeight: "700",
                                                color: "#212529"
                                            },
                                            children: "업무 목표 및 범위"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_base_BasicFormWrapper__WEBPACK_IMPORTED_MODULE_16__/* .Line */ .x1, {})
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                    className: "desc",
                                    style: {
                                        lineHeight: "1.6",
                                        color: "#495057",
                                        marginBottom: "16px",
                                        whiteSpace: "pre-line"
                                    },
                                    children: proposal === null || proposal === void 0 ? void 0 : proposal.purpose
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                    className: "desc",
                                    style: {
                                        lineHeight: "1.6",
                                        color: "#495057",
                                        marginBottom: "16px",
                                        whiteSpace: "pre-line"
                                    },
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(linkify_react__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                                        as: "span",
                                        options: {
                                            className: "linkify",
                                            target: "_blank"
                                        },
                                        children: proposal === null || proposal === void 0 ? void 0 : proposal.plan
                                    })
                                }),
                                (proposal.comment || proposal.fileUrl || proposal.workType || proposal.workTypeComment) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_src_component_SignComponent__WEBPACK_IMPORTED_MODULE_2__/* .EmptySpace */ .zV, {
                                            space: 24
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Row, {
                                            style: {
                                                gap: 16,
                                                flexDirection: "column",
                                                justifyContent: "flex-start",
                                                alignItems: "flex-start",
                                                marginBottom: "20px"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                    className: "detail-title",
                                                    style: {
                                                        fontSize: "20px",
                                                        fontWeight: "700",
                                                        color: "#212529"
                                                    },
                                                    children: "참고 사항"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_base_BasicFormWrapper__WEBPACK_IMPORTED_MODULE_16__/* .Line */ .x1, {})
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                            className: "desc",
                                            style: {
                                                lineHeight: "1.6",
                                                color: "#495057",
                                                whiteSpace: "pre-line"
                                            },
                                            children: [
                                                "".concat(proposal.workType ? "".concat(proposal.workType, "\n").concat(proposal.workTypeComment ? "".concat(proposal.workTypeComment, "\n") : "", "\n") : ""),
                                                proposal.comment ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(linkify_react__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                                                    as: "span",
                                                    options: {
                                                        className: "linkify",
                                                        target: "_blank"
                                                    },
                                                    children: proposal.comment
                                                }) : "",
                                                "\n",
                                                proposal.fileUrl && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
                                                    href: proposal.fileUrl,
                                                    style: {
                                                        color: "#007bff",
                                                        textDecoration: "underline"
                                                    },
                                                    children: "참고자료"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_base_BasicFormWrapper__WEBPACK_IMPORTED_MODULE_16__/* .WrapperContainer */ .t4, {
                            style: {
                                backgroundColor: "#ffffff",
                                borderRadius: "12px",
                                padding: "24px",
                                boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                                marginBottom: "24px"
                            },
                            children: [
                                !isExpert && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_base_BasicFormWrapper__WEBPACK_IMPORTED_MODULE_16__/* .TitleWrapper */ .$t, {
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                className: "top",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                        id: "top-title",
                                                        style: {
                                                            fontSize: "22px",
                                                            fontWeight: "700",
                                                            color: "#212529"
                                                        },
                                                        children: "서비스 요금"
                                                    })
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_src_component_SignComponent__WEBPACK_IMPORTED_MODULE_2__/* .EmptySpace */ .zV, {
                                            space: 24
                                        })
                                    ]
                                }),
                                isExpert ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                        style: {
                                            backgroundColor: "#f8f9fa",
                                            padding: "16px",
                                            borderRadius: "8px",
                                            border: "1px solid #e9ecef"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Row, {
                                                style: {
                                                    justifyContent: "space-between",
                                                    marginBottom: "12px"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                        style: {
                                                            fontWeight: "600",
                                                            color: "#495057"
                                                        },
                                                        children: "서비스 유형"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                        style: {
                                                            color: "#6c757d"
                                                        },
                                                        children: proposal.serviceType
                                                    })
                                                ]
                                            }),
                                            proposal.serviceType === "시간제" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Row, {
                                                style: {
                                                    justifyContent: "space-between",
                                                    marginBottom: "12px"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                        style: {
                                                            fontWeight: "600",
                                                            color: "#495057"
                                                        },
                                                        children: "시간제 플랜"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                        style: {
                                                            color: "#6c757d"
                                                        },
                                                        children: proposal.timeopt === "0시간" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                            style: {
                                                                color: "#6c757d"
                                                            },
                                                            children: "개별 협의"
                                                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                            children: "주 ".concat(proposal.timeopt)
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Row, {
                                                style: {
                                                    justifyContent: "space-between"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                        style: {
                                                            fontWeight: "600",
                                                            color: "#495057"
                                                        },
                                                        children: "전문가 대금"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                                        style: {
                                                            fontSize: "18px",
                                                            fontWeight: "700",
                                                            color: "#007bff"
                                                        },
                                                        children: [
                                                            (0,_src_utils_CalculationUtils__WEBPACK_IMPORTED_MODULE_35__/* .numberWithCommasFromNumber */ .tw)(Number(proposal.expertCost || 0) * 10000),
                                                            "원",
                                                            proposal.serviceType === "시간제" && " (".concat(uuid === "yu58enj116hbmxnvyw30ryu58y4z9pao" ? "6주" : "4주", ")")
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                            style: {
                                                marginBottom: "24px"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                    style: {
                                                        fontSize: "18px",
                                                        fontWeight: "600",
                                                        color: "#495057",
                                                        marginBottom: "16px"
                                                    },
                                                    children: "서비스 내역"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_base_BasicFormWrapper__WEBPACK_IMPORTED_MODULE_16__/* .Line */ .x1, {
                                                    style: {
                                                        marginBottom: "16px"
                                                    }
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                                    style: {
                                                        backgroundColor: "#f8f9fa",
                                                        padding: "16px",
                                                        borderRadius: "8px",
                                                        border: "1px solid #e9ecef"
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Row, {
                                                            style: {
                                                                justifyContent: "space-between",
                                                                marginBottom: "12px"
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                                    style: {
                                                                        fontWeight: "600",
                                                                        color: "#495057"
                                                                    },
                                                                    children: "전문가명"
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                                    style: {
                                                                        color: "#6c757d"
                                                                    },
                                                                    children: proposal.expert
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Row, {
                                                            style: {
                                                                justifyContent: "space-between",
                                                                marginBottom: "12px"
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                                    style: {
                                                                        fontWeight: "600",
                                                                        color: "#495057"
                                                                    },
                                                                    children: "서비스 유형"
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                                    style: {
                                                                        color: "#6c757d"
                                                                    },
                                                                    children: proposal.serviceType
                                                                })
                                                            ]
                                                        }),
                                                        proposal.serviceType === "시간제" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Row, {
                                                            style: {
                                                                justifyContent: "space-between"
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                                    style: {
                                                                        fontWeight: "600",
                                                                        color: "#495057"
                                                                    },
                                                                    children: "시간제 플랜"
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                                    style: {
                                                                        color: "#6c757d"
                                                                    },
                                                                    children: proposal.timeopt === "0시간" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                                        style: {
                                                                            color: "#6c757d"
                                                                        },
                                                                        children: "개별 협의"
                                                                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                                        children: "주 ".concat(proposal.timeopt)
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                            style: {
                                                marginBottom: "24px"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Row, {
                                                    style: {
                                                        justifyContent: "space-between",
                                                        marginBottom: "16px"
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                            style: {
                                                                fontSize: "18px",
                                                                fontWeight: "600",
                                                                color: "#495057"
                                                            },
                                                            children: "서비스 요금"
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                                            style: {
                                                                fontSize: "20px",
                                                                fontWeight: "700",
                                                                color: "#007bff"
                                                            },
                                                            children: [
                                                                (0,_src_utils_CalculationUtils__WEBPACK_IMPORTED_MODULE_35__/* .numberWithCommasFromNumber */ .tw)(Number(proposal.cost || 0) * 10000),
                                                                "원",
                                                                proposal.serviceType === "시간제" && " (".concat(uuid === "yu58enj116hbmxnvyw30ryu58y4z9pao" ? "6주" : "4주", ")")
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_base_BasicFormWrapper__WEBPACK_IMPORTED_MODULE_16__/* .Line */ .x1, {
                                                    style: {
                                                        marginBottom: "16px"
                                                    }
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Row, {
                                                    style: {
                                                        justifyContent: "flex-end"
                                                    },
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                        style: {
                                                            color: "#6c757d",
                                                            fontSize: "14px"
                                                        },
                                                        children: "VAT 10% 별도"
                                                    })
                                                })
                                            ]
                                        }),
                                        proposal.costTen || proposal.costFifteen || proposal.costTwenty ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                            style: {
                                                marginBottom: "24px"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                    style: {
                                                        fontSize: "18px",
                                                        fontWeight: "600",
                                                        color: "#495057",
                                                        marginBottom: "16px"
                                                    },
                                                    children: "참고사항"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                    style: {
                                                        color: "#6c757d",
                                                        lineHeight: "1.5",
                                                        marginBottom: "16px"
                                                    },
                                                    children: "다른 투입 시간으로 진행을 희망하신다면 원포인트에 조율 요청하기를 클릭해주세요."
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_base_BasicFormWrapper__WEBPACK_IMPORTED_MODULE_16__/* .Line */ .x1, {
                                                    style: {
                                                        marginBottom: "16px"
                                                    }
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                                    style: {
                                                        backgroundColor: "#f8f9fa",
                                                        padding: "16px",
                                                        borderRadius: "8px",
                                                        border: "1px solid #e9ecef"
                                                    },
                                                    children: [
                                                        proposal.costTen && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Row, {
                                                            style: {
                                                                justifyContent: "space-between",
                                                                marginBottom: "8px"
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                                    style: {
                                                                        color: "#495057"
                                                                    },
                                                                    children: "주 10시간"
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                                                    style: {
                                                                        color: "#6c757d"
                                                                    },
                                                                    children: [
                                                                        proposal.costTen,
                                                                        "만원 / 4주"
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        proposal.costFifteen && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Row, {
                                                            style: {
                                                                justifyContent: "space-between",
                                                                marginBottom: "8px"
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                                    style: {
                                                                        color: "#495057"
                                                                    },
                                                                    children: "주 15시간"
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                                                    style: {
                                                                        color: "#6c757d"
                                                                    },
                                                                    children: [
                                                                        proposal.costFifteen,
                                                                        "만원 / 4주"
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        proposal.costTwenty && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Row, {
                                                            style: {
                                                                justifyContent: "space-between"
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                                    style: {
                                                                        color: "#495057"
                                                                    },
                                                                    children: "주 20시간"
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                                                    style: {
                                                                        color: "#6c757d"
                                                                    },
                                                                    children: [
                                                                        proposal.costTwenty,
                                                                        "만원 / 4주"
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_src_component_SignComponent__WEBPACK_IMPORTED_MODULE_2__/* .EmptySpace */ .zV, {
                                                    space: 20
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(CustomButton, {
                                                    className: "btn",
                                                    fullWidth: true,
                                                    variant: "contained",
                                                    onClick: function() {
                                                        openDialog({
                                                            title: "상담 창으로 이동합니다.",
                                                            message: "",
                                                            desc: "상담 채널에서 조율이 필요한 내용을 말씀해주세요.",
                                                            btn2Text: "확인하기",
                                                            onClickBtn: /*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_24__/* ["default"] */ .Z)(function() {
                                                                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_25__.__generator)(this, function(_state) {
                                                                    window.open("https://1point.channel.io/home");
                                                                    return [
                                                                        2
                                                                    ];
                                                                });
                                                            })
                                                        });
                                                    },
                                                    style: {
                                                        border: "2px solid var(--primary)",
                                                        color: "var(--primary)",
                                                        backgroundColor: "transparent",
                                                        minHeight: "48px",
                                                        fontSize: "14px",
                                                        fontWeight: "600",
                                                        borderRadius: "8px"
                                                    },
                                                    children: "원포인트에 조율 요청하기"
                                                })
                                            ]
                                        }) : null,
                                        proposal.serviceType !== "프로젝트" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                            style: {
                                                backgroundColor: "#e3f2fd",
                                                padding: "16px",
                                                borderRadius: "8px",
                                                border: "1px solid #2196f3",
                                                textAlign: "center"
                                            },
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                                style: {
                                                    color: "#1976d2",
                                                    fontSize: "14px",
                                                    fontWeight: "600"
                                                },
                                                children: [
                                                    "장기 계약으로 ",
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
                                                        href: "https://docs.channel.io/onepoint/ko/articles/ff6c6176-장기-협업장기계약",
                                                        target: "_blank",
                                                        rel: "noreferrer",
                                                        style: {
                                                            color: "#1976d2",
                                                            textDecoration: "underline",
                                                            cursor: "pointer"
                                                        },
                                                        children: "5% 추가할인"
                                                    }),
                                                    " 받아보세요!"
                                                ]
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        matchedExpertDataUuid && !proposal.isAccepted && user.isLogin && user.userType === 1 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                            style: {
                                width: "100%",
                                maxWidth: "100%",
                                backgroundColor: "#ffffff",
                                padding: "24px",
                                borderRadius: "16px",
                                boxShadow: "0 4px 20px rgba(0, 0, 0, 0.08)",
                                border: "1px solid #e9ecef",
                                marginBottom: "24px"
                            },
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Column, {
                                style: {
                                    gap: 20
                                },
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                        style: {
                                            backgroundColor: "#f8f9fb",
                                            padding: "12px 16px",
                                            borderRadius: "8px",
                                            border: "1px solid #e9ecef",
                                            fontSize: "13px",
                                            lineHeight: 1.6,
                                            color: "#5b6473",
                                            wordBreak: "keep-all"
                                        },
                                        children: "전문가님 한 분과 협업이 확정되면 다른 전문가님들의 매칭은 자동으로 종료됩니다. 추가 고용을 원하시는 경우, 오른쪽 하단의 '문의하기'를 이용하여 말씀해 주시면 감사하겠습니다."
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Row, {
                                        style: {
                                            gap: 16
                                        },
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(CustomButton, {
                                            className: "btn",
                                            fullWidth: true,
                                            variant: "contained",
                                            onClick: function() {
                                                return setOpen(true);
                                            },
                                            style: {
                                                border: "none",
                                                backgroundColor: "var(--primary)",
                                                color: "white",
                                                whiteSpace: "nowrap",
                                                overflow: "hidden",
                                                textOverflow: "ellipsis",
                                                minHeight: "52px",
                                                fontSize: "15px",
                                                fontWeight: "600",
                                                borderRadius: "12px",
                                                transition: "all 0.2s ease"
                                            },
                                            children: "고용하기"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Row, {
                                        children: [
                                            !proposal.costTen && !proposal.costFifteen && !proposal.costTwenty ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(NegotiationButton, {
                                                className: "btn",
                                                fullWidth: true,
                                                variant: "contained",
                                                onClick: function() {
                                                    openDialog({
                                                        title: "상담 창으로 이동합니다.",
                                                        message: "",
                                                        desc: "상담 채널에서 조율이 필요한 내용을 말씀해주세요.",
                                                        btn2Text: "확인하기",
                                                        onClickBtn: /*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_24__/* ["default"] */ .Z)(function() {
                                                            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_25__.__generator)(this, function(_state) {
                                                                window.open("https://1point.channel.io/home");
                                                                return [
                                                                    2
                                                                ];
                                                            });
                                                        })
                                                    });
                                                },
                                                children: "원포인트에 조율 요청하기"
                                            }) : null,
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(NegotiationButton, {
                                                className: "btn",
                                                fullWidth: true,
                                                variant: "contained",
                                                onClick: function() {
                                                    setOpenRejectModal(true);
                                                },
                                                children: "거절하기"
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_src_component_SignComponent__WEBPACK_IMPORTED_MODULE_2__/* .EmptySpace */ .zV, {
                            space: !proposal.isAccepted && matchedExpertDataUuid && user.isLogin && user.userType === 1 ? 96 : 32
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ProposalAcceptDialog, {
                maxWidth: "md",
                fullWidth: true,
                open: open,
                sx: {
                    zIndex: 20000
                },
                onClose: function() {
                    return setOpen(false);
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("form", {
                    onSubmit: handleSubmit(function(data) {
                        handleOnClickAccept(data);
                    }),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_36__/* ["default"] */ .Z, {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                className: "title-box",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                        className: "title",
                                        children: "제안서 수락을 위한\n마지막 단계입니다!"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                        className: "icon",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("img", {
                                            className: "logo",
                                            src: "/static/image/logo_white.svg"
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_37__/* ["default"] */ .Z, {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                    className: "description",
                                    children: isValidDate ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                                        children: [
                                            "전문가님의 업무 시작 가능일은 ",
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                                className: "blue",
                                                children: moment__WEBPACK_IMPORTED_MODULE_12___default()(proposal.desiredStartDate).format("M월 D일")
                                            }),
                                            "입니다.\n해당 날짜 이후 일자 중 업무 시작일을 선택해주세요."
                                        ]
                                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                                        children: "업무 시작일을 선택해주세요."
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                    className: "description-mini",
                                    children: "• 선택하신 업무 시작일 전까지 계약서 서명과 서비스 대금 결제가 진행되어야 하는 점 참고해주세요\n• 선택 가능 일자를 벗어나는 날짜에 업무를 시작하고자 하시는 경우 원포인트 채널톡으로 별도 문의해주세요"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_src_component_SignComponent__WEBPACK_IMPORTED_MODULE_2__/* .EmptySpace */ .zV, {
                                    space: 10
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_x_date_pickers__WEBPACK_IMPORTED_MODULE_38__/* .LocalizationProvider */ ._, {
                                    dateFormats: {
                                        monthShort: "MM",
                                        monthAndYear: "yyyy.MM"
                                    },
                                    dateAdapter: _mui_x_date_pickers_AdapterMoment__WEBPACK_IMPORTED_MODULE_39__/* .AdapterMoment */ .Q,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_hook_form__WEBPACK_IMPORTED_MODULE_21__/* .Controller */ .Qr, {
                                        name: "desiredStartDate",
                                        control: control,
                                        defaultValue: new Date(),
                                        rules: {
                                            required: "필수입니다.",
                                            validate: function(value) {
                                                var dateObj = moment__WEBPACK_IMPORTED_MODULE_12___default()(value);
                                                // console.log(dateObj, moment());
                                                if (dateObj.isBefore(moment__WEBPACK_IMPORTED_MODULE_12___default()())) {
                                                    return "시작일 이전일 수 없습니다.";
                                                } else {
                                                    return undefined;
                                                }
                                            }
                                        },
                                        render: function(_param) {
                                            var _field = _param.field, ref = _field.ref, value = _field.value, onChange = _field.onChange, error = _param.fieldState.error, field = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_40__/* ["default"] */ .Z)(_param.field, [
                                                "ref",
                                                "value",
                                                "onChange"
                                            ]);
                                            /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_x_date_pickers__WEBPACK_IMPORTED_MODULE_41__/* .DatePicker */ .M, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z)({}, field), {
                                                onChange: function(value) {
                                                    if (value) {
                                                        onChange(value === null || value === void 0 ? void 0 : value.toDate());
                                                    }
                                                },
                                                minDate: moment__WEBPACK_IMPORTED_MODULE_12___default()(),
                                                format: "YYYY.MM.DD",
                                                slotProps: {
                                                    textField: {
                                                        variant: "outlined",
                                                        error: !!error,
                                                        helperText: error === null || error === void 0 ? void 0 : error.message,
                                                        autoFocus: true,
                                                        inputRef: ref,
                                                        fullWidth: true,
                                                        sx: {
                                                            paddingRight: 10
                                                        }
                                                    }
                                                },
                                                value: moment__WEBPACK_IMPORTED_MODULE_12___default()(value)
                                            }));
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                    className: "description",
                                    children: "정부/민간 지원금 대상 여부를 알려주세요."
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                    className: "description-mini",
                                    children: "• 지원금을 사용하는 경우 제안서 수락 후 영업일 2일 이내 담당 매니저가 별도로 연락드립니다."
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_src_component_SignComponent__WEBPACK_IMPORTED_MODULE_2__/* .EmptySpace */ .zV, {
                                    space: 10
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_hook_form__WEBPACK_IMPORTED_MODULE_21__/* .Controller */ .Qr, {
                                    name: "useSupportFund",
                                    control: control,
                                    rules: {
                                        validate: function(value) {
                                            if (value === null) {
                                                return "필수값입니다";
                                            } else {
                                                return undefined;
                                            }
                                        }
                                    },
                                    defaultValue: null,
                                    render: function(_param) {
                                        var _field = _param.field, ref = _field.ref, onChange = _field.onChange, onBlur = _field.onBlur, error = _param.fieldState.error, field = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_40__/* ["default"] */ .Z)(_param.field, [
                                            "ref",
                                            "onChange",
                                            "onBlur"
                                        ]);
                                        /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                                    className: "button-group",
                                                    ref: ref,
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_27__/* ["default"] */ .Z, {
                                                            variant: useSupportFund ? "contained" : "outlined",
                                                            onClick: function() {
                                                                return onChange(true);
                                                            },
                                                            onBlur: onBlur,
                                                            children: "네, 지원금 대상으로 사용 예정이에요"
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_27__/* ["default"] */ .Z, {
                                                            variant: useSupportFund === false ? "contained" : "outlined",
                                                            onClick: function() {
                                                                return onChange(false);
                                                            },
                                                            onBlur: onBlur,
                                                            children: "아니요, 대상이 아니거나 사용하지 않아요"
                                                        })
                                                    ]
                                                }),
                                                (error === null || error === void 0 ? void 0 : error.message) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_42__/* ["default"] */ .Z, {
                                                    error: true,
                                                    children: error === null || error === void 0 ? void 0 : error.message
                                                })
                                            ]
                                        });
                                    }
                                }),
                                useSupportFund && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_src_component_SignComponent__WEBPACK_IMPORTED_MODULE_2__/* .EmptySpace */ .zV, {
                                            space: 20
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                            className: "description-mini",
                                            children: "• 지원금은 집행처에 따라 사용 가능 여부와 방법이 상이합니다.\n• 사전에 집행처에 사용 가능 여부를 확인하셔야합니다."
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_src_component_SignComponent__WEBPACK_IMPORTED_MODULE_2__/* .EmptySpace */ .zV, {
                                            space: 10
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_hook_form__WEBPACK_IMPORTED_MODULE_21__/* .Controller */ .Qr, {
                                            name: "understandSupportFund",
                                            control: control,
                                            rules: {
                                                validate: function(value) {
                                                    if (value === false) {
                                                        return "필수값입니다";
                                                    } else {
                                                        return undefined;
                                                    }
                                                }
                                            },
                                            defaultValue: false,
                                            render: function(_param) {
                                                var _field = _param.field, ref = _field.ref, onChange = _field.onChange, onBlur = _field.onBlur, error = _param.fieldState.error, field = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_40__/* ["default"] */ .Z)(_param.field, [
                                                    "ref",
                                                    "onChange",
                                                    "onBlur"
                                                ]);
                                                /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                            className: "button-group",
                                                            ref: ref,
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_27__/* ["default"] */ .Z, {
                                                                variant: watch("understandSupportFund") ? "contained" : "outlined",
                                                                onClick: function() {
                                                                    return onChange(!watch("understandSupportFund"));
                                                                },
                                                                onBlur: onBlur,
                                                                children: "네, 이해했어요"
                                                            })
                                                        }),
                                                        (error === null || error === void 0 ? void 0 : error.message) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_42__/* ["default"] */ .Z, {
                                                            error: true,
                                                            children: error === null || error === void 0 ? void 0 : error.message
                                                        })
                                                    ]
                                                });
                                            }
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                            className: "description",
                                            children: "해당되는 지원금 종류와 집행처를 알려주세요"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_src_component_SignComponent__WEBPACK_IMPORTED_MODULE_2__/* .EmptySpace */ .zV, {
                                            space: 10
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_hook_form__WEBPACK_IMPORTED_MODULE_21__/* .Controller */ .Qr, {
                                            name: "supportInfo",
                                            control: control,
                                            rules: {
                                                required: "필수값입니다"
                                            },
                                            defaultValue: null,
                                            render: function(_param) {
                                                var ref = _param.field.ref, error = _param.fieldState.error, field = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_40__/* ["default"] */ .Z)(_param.field, [
                                                    "ref"
                                                ]);
                                                /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_43__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z)({
                                                    fullWidth: true,
                                                    inputRef: ref
                                                }, field), {
                                                    error: !!error,
                                                    helperText: error === null || error === void 0 ? void 0 : error.message
                                                }));
                                            }
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_44__/* ["default"] */ .Z, {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_27__/* ["default"] */ .Z, {
                                sx: {
                                    borderRadius: 2,
                                    width: "150px",
                                    fontWeight: "bold",
                                    fontSize: "16px"
                                },
                                variant: "contained",
                                type: "submit",
                                children: "제출하기"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_base_OnePointDialog__WEBPACK_IMPORTED_MODULE_18__/* .OnePointDialog */ .b, {
                maxWidth: "sm",
                fullWidth: true,
                open: openRejectModal,
                onClose: function() {
                    setOpenRejectModal(false);
                },
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_36__/* ["default"] */ .Z, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                    className: "helptext",
                                    children: "본\xa0업무 범위\xa0제안을 거절하시는 경우,\xa0번복이 어렵습니다."
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                    className: "title",
                                    children: "".concat(proposal.expert, "님과\n업무를 진행하지 않는 이유를 알려주세요")
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("form", {
                        onSubmit: rejectHandleOnSubmit(function(data) {
                            mutateHandleOnClickRejectByClient({
                                matchedExpertDataUuid: matchedExpertDataUuid,
                                reason: data.formResponse === "기타" ? "기타: " + data.etc : data.formResponse
                            });
                        }, function(error) {
                        // console.log(error);
                        }),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_37__/* ["default"] */ .Z, {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                    style: {
                                        flexDirection: "column"
                                    },
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_45__/* ["default"] */ .Z, {
                                        fullWidth: true,
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_hook_form__WEBPACK_IMPORTED_MODULE_21__/* .Controller */ .Qr, {
                                                name: "formResponse",
                                                control: controlReject,
                                                rules: {
                                                    required: "필수 입력 항목입니다."
                                                },
                                                render: function(_param) {
                                                    var ref = _param.field.ref, error = _param.fieldState.error, field = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_40__/* ["default"] */ .Z)(_param.field, [
                                                        "ref"
                                                    ]);
                                                    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                                                        children: [
                                                            error && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_42__/* ["default"] */ .Z, {
                                                                error: true,
                                                                children: error === null || error === void 0 ? void 0 : error.message
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_46__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z)({}, field), {
                                                                children: rejectReason.map(function(reason, index) {
                                                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_47__/* ["default"] */ .Z, {
                                                                            control: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_48__/* ["default"] */ .Z, {}),
                                                                            label: reason,
                                                                            value: reason
                                                                        }, "radio-formresponse-" + index.toString())
                                                                    });
                                                                })
                                                            }))
                                                        ]
                                                    });
                                                }
                                            }),
                                            watchReject("formResponse") === "기타" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_hook_form__WEBPACK_IMPORTED_MODULE_21__/* .Controller */ .Qr, {
                                                name: "etc",
                                                control: controlReject,
                                                rules: {
                                                    required: "필수 입력 항목입니다."
                                                },
                                                render: function(_param) {
                                                    var ref = _param.field.ref, error = _param.fieldState.error, field = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_40__/* ["default"] */ .Z)(_param.field, [
                                                        "ref"
                                                    ]);
                                                    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_43__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z)({
                                                            fullWidth: true,
                                                            multiline: true,
                                                            minRows: 2,
                                                            placeholder: "사유를 입력해주세요",
                                                            inputRef: ref
                                                        }, field), {
                                                            error: !!error,
                                                            helperText: error === null || error === void 0 ? void 0 : error.message
                                                        }))
                                                    });
                                                }
                                            })
                                        ]
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_44__/* ["default"] */ .Z, {
                                style: {
                                    marginBottom: "16px"
                                },
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_lab__WEBPACK_IMPORTED_MODULE_49__/* ["default"] */ .Z, {
                                        sx: {
                                            borderRadius: 2,
                                            fontWeight: "bold",
                                            fontSize: "16px"
                                        },
                                        variant: "outlined",
                                        onClick: function() {
                                            setOpenRejectModal(false);
                                        },
                                        children: "닫기"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_lab__WEBPACK_IMPORTED_MODULE_49__/* ["default"] */ .Z, {
                                        sx: {
                                            borderRadius: 2,
                                            fontWeight: "bold",
                                            fontSize: "16px",
                                            width: "150px"
                                        },
                                        variant: "contained",
                                        loading: isLoadingHandleOnClickRejectByClient,
                                        type: "submit",
                                        children: "거절하기"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            (depositStatus === null || depositStatus === void 0 ? void 0 : depositStatus.depositUuid) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_base_OnePointDialog__WEBPACK_IMPORTED_MODULE_18__/* .OnePointDialog */ .b, {
                open: openDepositRefundModal,
                onClose: function() {
                    return setOpenDepositRefundModal(false);
                },
                maxWidth: "sm",
                fullWidth: true,
                sx: {
                    "& .MuiDialog-paper": {
                        borderRadius: "18px"
                    }
                },
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_36__/* ["default"] */ .Z, {
                        sx: {
                            backgroundColor: "var(--primary)",
                            color: "white",
                            textAlign: "center",
                            padding: "32px 24px 24px"
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                            style: {
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                gap: "12px"
                            },
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                style: {
                                    fontSize: "24px",
                                    fontWeight: "700"
                                },
                                children: "서비스 보증금 환불 안내"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_37__/* ["default"] */ .Z, {
                        sx: {
                            padding: "48px 32px 40px"
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                            style: {
                                textAlign: "center",
                                lineHeight: "1.7"
                            },
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                    style: {
                                        fontSize: "16px",
                                        fontWeight: "600",
                                        marginTop: "32px",
                                        marginBottom: "24px",
                                        color: "#333",
                                        lineHeight: "1.5"
                                    },
                                    children: "서비스 보증금 환불 요청이 완료되었습니다."
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                    style: {
                                        fontSize: "16px",
                                        color: "#666",
                                        marginBottom: "8px",
                                        lineHeight: "1.6"
                                    },
                                    children: "담당자가 3일 이내에 환불해드리도록 하겠습니다."
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                    style: {
                                        fontSize: "16px",
                                        color: "#666",
                                        lineHeight: "1.6"
                                    },
                                    children: "문의사항이 있으실 경우 채널톡으로 문의 부탁드립니다."
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_44__/* ["default"] */ .Z, {
                        sx: {
                            padding: "0 32px 32px"
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_27__/* ["default"] */ .Z, {
                            onClick: function() {
                                setOpenDepositRefundModal(false);
                                router.replace("/match/my");
                            },
                            variant: "contained",
                            fullWidth: true,
                            sx: {
                                backgroundColor: "var(--primary)",
                                color: "white",
                                fontWeight: "bold",
                                padding: "14px",
                                borderRadius: "12px",
                                fontSize: "16px",
                                "&:hover": {
                                    backgroundColor: "var(--primary)",
                                    opacity: 0.9
                                }
                            },
                            children: "확인"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_50__/* ["default"] */ .Z, {
                open: openAiFeedbackModal,
                onClose: function() {
                    return setOpenAiFeedbackModal(false);
                },
                maxWidth: "xs",
                fullWidth: true,
                PaperProps: {
                    sx: {
                        borderRadius: "16px"
                    }
                },
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_36__/* ["default"] */ .Z, {
                        sx: {
                            textAlign: "center",
                            pt: 3,
                            pb: 1
                        },
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_icons_material_AutoAwesomeRounded__WEBPACK_IMPORTED_MODULE_28__/* ["default"] */ .Z, {
                                sx: {
                                    color: "#7c3aed",
                                    fontSize: 28,
                                    mb: 0.5
                                }
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_31__/* ["default"] */ .Z, {
                                sx: {
                                    fontSize: 18,
                                    fontWeight: 800,
                                    color: "#111827"
                                },
                                children: "AI 후보자 분석이 도움이 되셨나요?"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_37__/* ["default"] */ .Z, {
                        sx: {
                            textAlign: "center",
                            px: 3,
                            pb: 1
                        },
                        children: !aiFeedbackSubmitted ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material_Rating__WEBPACK_IMPORTED_MODULE_51__/* ["default"] */ .Z, {
                                    value: aiFeedbackRating,
                                    onChange: function(_, value) {
                                        return setAiFeedbackRating(value);
                                    },
                                    precision: 0.5,
                                    size: "large",
                                    sx: {
                                        mt: 1,
                                        mb: 2,
                                        "& .MuiRating-iconFilled": {
                                            color: "#7c3aed"
                                        },
                                        "& .MuiRating-iconHover": {
                                            color: "#6d28d9"
                                        }
                                    }
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_43__/* ["default"] */ .Z, {
                                    value: aiFeedbackComment,
                                    onChange: function(e) {
                                        return setAiFeedbackComment(e.target.value);
                                    },
                                    placeholder: "의견을 남겨주세요 (선택사항)",
                                    multiline: true,
                                    rows: 2,
                                    fullWidth: true,
                                    variant: "outlined",
                                    sx: {
                                        mb: 1,
                                        "& .MuiOutlinedInput-root": {
                                            borderRadius: "10px",
                                            fontSize: 14
                                        }
                                    }
                                })
                            ]
                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_31__/* ["default"] */ .Z, {
                            sx: {
                                py: 3,
                                fontSize: 15,
                                color: "#374151"
                            },
                            children: "피드백을 보내주셔서 감사합니다!"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_44__/* ["default"] */ .Z, {
                        sx: {
                            px: 3,
                            pb: 3,
                            gap: 1
                        },
                        children: !aiFeedbackSubmitted ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_27__/* ["default"] */ .Z, {
                                    fullWidth: true,
                                    onClick: function() {
                                        return setOpenAiFeedbackModal(false);
                                    },
                                    sx: {
                                        borderRadius: "10px",
                                        color: "#6b7280"
                                    },
                                    children: "건너뛰기"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_27__/* ["default"] */ .Z, {
                                    fullWidth: true,
                                    variant: "contained",
                                    disabled: !aiFeedbackRating,
                                    onClick: /*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_24__/* ["default"] */ .Z)(function() {
                                        var _tmp, e;
                                        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_25__.__generator)(this, function(_state) {
                                            switch(_state.label){
                                                case 0:
                                                    if (!aiFeedbackRating) return [
                                                        2
                                                    ];
                                                    _state.label = 1;
                                                case 1:
                                                    _state.trys.push([
                                                        1,
                                                        3,
                                                        ,
                                                        4
                                                    ]);
                                                    _tmp = {};
                                                    return [
                                                        4,
                                                        (0,_src_api_match__WEBPACK_IMPORTED_MODULE_10__.sendProposalAssistantFeedback)((_tmp.matchUuid = proposal.matchUuid, _tmp.rating = aiFeedbackRating, _tmp.comment = aiFeedbackComment || undefined, _tmp))
                                                    ];
                                                case 2:
                                                    _state.sent();
                                                    setAiFeedbackSubmitted(true);
                                                    setTimeout(function() {
                                                        return setOpenAiFeedbackModal(false);
                                                    }, 1500);
                                                    return [
                                                        3,
                                                        4
                                                    ];
                                                case 3:
                                                    e = _state.sent();
                                                    setOpenAiFeedbackModal(false);
                                                    return [
                                                        3,
                                                        4
                                                    ];
                                                case 4:
                                                    return [
                                                        2
                                                    ];
                                            }
                                        });
                                    }),
                                    sx: {
                                        borderRadius: "10px",
                                        fontWeight: 700,
                                        backgroundColor: "#7c3aed",
                                        "&:hover": {
                                            backgroundColor: "#6d28d9"
                                        }
                                    },
                                    children: "제출하기"
                                })
                            ]
                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_27__/* ["default"] */ .Z, {
                            fullWidth: true,
                            variant: "contained",
                            onClick: function() {
                                return setOpenAiFeedbackModal(false);
                            },
                            sx: {
                                borderRadius: "10px",
                                fontWeight: 700,
                                backgroundColor: "#7c3aed",
                                "&:hover": {
                                    backgroundColor: "#6d28d9"
                                }
                            },
                            children: "닫기"
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["ZP"] = (ProposalView);
var Row = _emotion_styled__WEBPACK_IMPORTED_MODULE_9__/* ["default"].div */ .Z.div(_templateObject());
var Column = _emotion_styled__WEBPACK_IMPORTED_MODULE_9__/* ["default"].div */ .Z.div(_templateObject1());
var ProposalAcceptDialog = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_mui_material__WEBPACK_IMPORTED_MODULE_50__/* ["default"] */ .Z)(_templateObject2());
var BlueText = _emotion_styled__WEBPACK_IMPORTED_MODULE_9__/* ["default"].div */ .Z.div(_templateObject3());
var CustomButton = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_mui_material__WEBPACK_IMPORTED_MODULE_27__/* ["default"] */ .Z)(_templateObject4());
var NegotiationButton = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_mui_material__WEBPACK_IMPORTED_MODULE_27__/* ["default"] */ .Z)(_templateObject5());


/***/ }),

/***/ 81762:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(82670);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(20414);
/* harmony import */ var _src_api_match__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91088);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_query__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88767);






var useProposalAssistant = function(matchUuid) {
    var ref, ref1, ref2, ref3, ref4;
    var queryClient = (0,react_query__WEBPACK_IMPORTED_MODULE_2__.useQueryClient)();
    var queryKey = [
        "matchProposalAssistant",
        matchUuid
    ];
    var generatingKey = [
        "proposalAssistantGenerating",
        matchUuid
    ];
    var errorKey = [
        "proposalAssistantError",
        matchUuid
    ];
    var generatingOverallKey = [
        "proposalAssistantGeneratingOverall",
        matchUuid
    ];
    var query = (0,react_query__WEBPACK_IMPORTED_MODULE_2__.useQuery)(queryKey, /*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function() {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!matchUuid) return [
                        2,
                        null
                    ];
                    return [
                        4,
                        (0,_src_api_match__WEBPACK_IMPORTED_MODULE_0__.getMatchProposalAssistant)(matchUuid)
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    }), {
        enabled: !!matchUuid,
        refetchOnWindowFocus: false,
        staleTime: 0,
        cacheTime: 5 * 60 * 1000
    });
    // reactive한 생성 상태 (useQuery로 구독)
    var ref5 = (0,react_query__WEBPACK_IMPORTED_MODULE_2__.useQuery)(generatingKey, function() {
        return !!queryClient.getQueryData(generatingKey);
    }, {
        enabled: !!matchUuid,
        staleTime: Infinity,
        cacheTime: Infinity,
        refetchOnWindowFocus: false
    }), tmp = ref5.data, isGenerating = tmp === void 0 ? false : tmp;
    var ref6 = (0,react_query__WEBPACK_IMPORTED_MODULE_2__.useQuery)(errorKey, function() {
        return queryClient.getQueryData(errorKey) || null;
    }, {
        enabled: !!matchUuid,
        staleTime: Infinity,
        cacheTime: Infinity,
        refetchOnWindowFocus: false
    }), tmp1 = ref6.data, generationError = tmp1 === void 0 ? null : tmp1;
    var generateReport = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(/*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function() {
        var forceRegenerate, matchedExpertDataUuid, _tmp;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
            forceRegenerate = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : false, matchedExpertDataUuid = _arguments.length > 1 ? _arguments[1] : void 0;
            if (!matchUuid) return [
                2,
                null
            ];
            if (isGenerating) return [
                2,
                null
            ];
            // 생성 중 상태 마킹 → useQuery 구독자들 리렌더링
            queryClient.setQueryData(generatingKey, true);
            queryClient.setQueryData(errorKey, null);
            _tmp = {};
            // fire-and-forget: 컴포넌트 unmount되어도 계속 실행
            (0,_src_api_match__WEBPACK_IMPORTED_MODULE_0__.generateMatchProposalAssistant)((_tmp.matchUuid = matchUuid, _tmp.matchedExpertDataUuid = matchedExpertDataUuid, _tmp.forceRegenerate = forceRegenerate, _tmp)).then(function(result) {
                if ((result === null || result === void 0 ? void 0 : result.isSuccess) && result.report) {
                    queryClient.setQueryData(queryKey, {
                        isSuccess: true,
                        exists: true,
                        sourceHash: result.sourceHash,
                        promptVersion: result.promptVersion,
                        model: result.model,
                        responseId: result.responseId,
                        generatedAt: result.generatedAt,
                        report: result.report
                    });
                } else {
                    queryClient.setQueryData(errorKey, (result === null || result === void 0 ? void 0 : result.message) || (result === null || result === void 0 ? void 0 : result.errorCode) || "리포트 생성에 실패했습니다.");
                    queryClient.invalidateQueries(queryKey);
                }
            }).catch(function(error) {
                var message = (0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(error, Error) ? error.message : null;
                queryClient.setQueryData(errorKey, message || "리포트 생성 중 오류가 발생했습니다.");
            }).finally(function() {
                queryClient.setQueryData(generatingKey, false);
            });
            return [
                2,
                null
            ];
        });
    }), [
        matchUuid,
        isGenerating,
        queryClient,
        generatingKey,
        errorKey,
        queryKey
    ]);
    var ref7 = (0,react_query__WEBPACK_IMPORTED_MODULE_2__.useQuery)(generatingOverallKey, function() {
        return !!queryClient.getQueryData(generatingOverallKey);
    }, {
        enabled: !!matchUuid,
        staleTime: Infinity,
        cacheTime: Infinity,
        refetchOnWindowFocus: false
    }), tmp2 = ref7.data, isGeneratingOverall = tmp2 === void 0 ? false : tmp2;
    var generateOverall = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(/*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function() {
        var forceRegenerate, _tmp;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
            forceRegenerate = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : false;
            if (!matchUuid) return [
                2
            ];
            if (isGeneratingOverall) return [
                2
            ];
            queryClient.setQueryData(generatingOverallKey, true);
            queryClient.setQueryData(errorKey, null);
            _tmp = {};
            (0,_src_api_match__WEBPACK_IMPORTED_MODULE_0__.generateOverallAssessment)((_tmp.matchUuid = matchUuid, _tmp.forceRegenerate = forceRegenerate, _tmp)).then(function(result) {
                if ((result === null || result === void 0 ? void 0 : result.isSuccess) && result.report) {
                    queryClient.setQueryData(queryKey, {
                        isSuccess: true,
                        exists: true,
                        report: result.report
                    });
                } else {
                    queryClient.setQueryData(errorKey, (result === null || result === void 0 ? void 0 : result.message) || (result === null || result === void 0 ? void 0 : result.errorCode) || "총평 생성에 실패했습니다.");
                }
            }).catch(function(error) {
                var message = (0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(error, Error) ? error.message : null;
                queryClient.setQueryData(errorKey, message || "총평 생성 중 오류가 발생했습니다.");
            }).finally(function() {
                queryClient.setQueryData(generatingOverallKey, false);
            });
            return [
                2
            ];
        });
    }), [
        matchUuid,
        isGeneratingOverall,
        queryClient,
        generatingOverallKey,
        errorKey,
        queryKey
    ]);
    var report = ((ref = query.data) === null || ref === void 0 ? void 0 : ref.report) || null;
    var expertReportMap = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        var map = new Map();
        if (report === null || report === void 0 ? void 0 : report.experts) {
            report.experts.forEach(function(expert) {
                map.set(expert.matchedExpertDataUuid, expert);
            });
        }
        return map;
    }, [
        report
    ]);
    return {
        isLoading: query.isLoading,
        isFetching: query.isFetching,
        isGenerating: !!isGenerating,
        isGeneratingOverall: !!isGeneratingOverall,
        exists: !!((ref1 = query.data) === null || ref1 === void 0 ? void 0 : ref1.exists),
        hasDeadlineSet: !!((ref2 = query.data) === null || ref2 === void 0 ? void 0 : ref2.hasDeadlineSet),
        report: report,
        generatedAt: ((ref3 = query.data) === null || ref3 === void 0 ? void 0 : ref3.generatedAt) || null,
        model: ((ref4 = query.data) === null || ref4 === void 0 ? void 0 : ref4.model) || null,
        generationError: generationError || null,
        expertReportMap: expertReportMap,
        refetch: query.refetch,
        generateReport: generateReport,
        generateOverall: generateOverall
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useProposalAssistant);


/***/ })

}]);